import { UserDetailsModel } from './../../../models/dashboard/users/userDetails';
import { adminHttpClient } from "../../../commons/adminHttpClinet";
import { UserModel, UserSearch } from "../../../models/dashboard/users/user";

const getUsersList = ( searchParams: UserSearch ): Promise<UserModel> => {
    return adminHttpClient.get(`/api/Admin/AdminUsers/get-users?OrderDescending=${searchParams.orderByDescending}&PageNumber=${searchParams.pageNumber}&PageSize=${searchParams.pageSize}&SearchValue=${encodeURIComponent(searchParams.searchValue)}&SortColumn=${searchParams.sortColumn}&Status=${searchParams.status}&CreatedFrom=${searchParams.createdAt.from}&CreatedTo=${searchParams.createdAt.to}
    &LoginFrom=${searchParams.loginAt.from}&LoginTo=${searchParams.loginAt.to}`)
}

export default getUsersList;